import { z } from "zod";
/**
 * Wire shape of every non-2xx response emitted by the API.
 *
 * Mirrors the body produced by `toErrorEnvelope()` in
 * `@cometchat-ai/core` (see `packages/core/src/errors.ts`) and the
 * `AppErrorFilter` / `UnknownErrorFilter` in
 * `packages/auth/src/server/nestjs/filters/`. Field naming matches the
 * over-the-wire JSON (snake_case `request_id`, `error` for the code).
 *
 * The dashboard's `AuthClientError` (see
 * `packages/auth/src/client/auth-client-error.ts`) wraps this envelope
 * in a camelCase view (`code`, `requestId`) for ergonomics, but the
 * OpenAPI spec describes the wire format, not the client wrapper.
 *
 * Registered once as the shared `ErrorEnvelope` OpenAPI component by
 * `apps/api/src/openapi.config.ts` and `$ref`-ed from every documented
 * non-2xx response per FD `business-rules.md § Standard error envelope`.
 */
export const errorEnvelopeSchema = z.object({
    /** Machine-readable error code (e.g., `NOT_FOUND`, `VALIDATION_ERROR`). */
    error: z.string(),
    /** Human-readable message. Safe to surface to end users. */
    message: z.string(),
    /** Correlation id for the failing request; matches the `x-request-id` header. */
    request_id: z.string(),
    /** Optional structured detail bag; shape varies by error code. */
    details: z.record(z.unknown()).optional(),
});
//# sourceMappingURL=error-envelope.schema.js.map